// import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import CircularProgress from '@material-ui/core/CircularProgress';
// import { Backdrop } from '@material-ui/core';

// const useStyles = makeStyles((theme) => ({
//   backdrop: {
//     zIndex: theme.zIndex.drawer + 1,
//     color: '#fff',
//   },
// }));

// const Loader = () => {
//   const classes = useStyles();

//   return (
//     <Backdrop className={classes.backdrop} open={true}>
//       <CircularProgress color="inherit" size={80} />
//     </Backdrop>
//   );
// };

// export default Loader;



import React from 'react';

const Loader = () => {
  return (
    <>
      <div className=' h-[90vh] md:h-[0px]'>

      </div>
      <div className="fixed border border-red-500 md:mt-0 inset-0 z-50 flex items-center justify-center bg-gray/70 backdrop-blur-sm">
        <div className="w-12 h-12 sm:w-16 sm:h-16 border-4 border-gray-300 border-t-gray-700 rounded-full animate-spin" />
      </div>
    </>
  );
};

export default Loader;
